.categories, .category, .overallScoreOutside, .overallScoreInside, .rating, .ratingCenter, .riskScores, .ratingIndicator {
    display: flex;
}

.category, .rating {
    justify-content: space-between;
}

.overallScoreOutside {
    width: 20%;
    padding-right: 20px;
    border-right: 1px solid #34586b;
}

.overallScoreInside {
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    text-align: center;
}

.overallScoreOutside, .categories, .ratingCenter {
    flex-wrap: wrap;
    justify-content: center;
}

.categories {
    width: 80%;
}

.missingCategories {
    margin: auto;
}

.carouselButtonPadding {
    padding-bottom: 30px;
}

.category {
    align-items: center;
    padding: 10px 30px;
    width: 300px;
}

.categoryName {
    width: 150px;
}

.ratingCenter {
    width: 100%;
}

.rating {
    width: 70px;
}

.ratingIndicator {
    align-items: center;
    width: 20px;
}
